import { useSuspenseQuery } from '@tanstack/react-query';
import { configService } from '../api/configService';
import { queryKey } from '../constant';

export const useConfigs = () => {
  return useSuspenseQuery({
    queryKey: queryKey.configs,
    queryFn: () => configService.getConfigs(),
  });
};
